import React from 'react';

const Privacy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold mb-6">Privacy Policy</h1>
      <p className="text-gray-600 mb-8">Last updated: {new Date().toLocaleDateString()}</p>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-3">Information We Collect</h2>
          <p className="text-gray-600">
            We collect information you provide directly, such as your name, email address, 
            and resume content. We also collect usage data to improve our service.
          </p>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold mb-3">How We Use Your Information</h2>
          <p className="text-gray-600">
            Your data is used to provide and improve our resume building service, 
            communicate with you, and ensure the security of our platform.
          </p>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold mb-3">Data Security</h2>
          <p className="text-gray-600">
            We implement industry-standard security measures to protect your data. 
            Your resume content is encrypted and stored securely.
          </p>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold mb-3">Your Rights</h2>
          <p className="text-gray-600">
            You have the right to access, modify, or delete your data at any time. 
            Contact us to exercise these rights.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;